import { Box, Paper, styled } from "@mui/material";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ImageAndTitle from "../../../components/dragNDrop/draggableElements/ImageAndTitle";

const PREFIX = "InfiniteContent";

const classes = {
  addList: `${PREFIX}-addList`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.addList}`]: {
    [theme.breakpoints.between("xs", "md")]: {
      width: "100%",
      overflowX: "auto",
      flexDirection: "row",
      flexBasis: "inherit",
      flexWrap: "inherit",
      height: "120px",
      marginBottom: "1.5rem",
      overflowY: "hidden",
    },
    padding: "0.5rem",
    width: "400px",
    height: "300px",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexWrap: "wrap",
    flexBasis: "33.333333%",
    backgroundColor: "#424242",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
  },
}));

const InfiniteContent = ({
  baseList,
  getNextElements,
  apiHasMore,
  id,
  ddList,
  logoKey,
  subLogoKey,
  handleAddElement,
}) => {
  return (
    <InfiniteScroll
      dataLength={baseList.length}
      next={() => getNextElements()}
      hasMore={apiHasMore}
      scrollableTarget={`${id}-infinite-scroll`}
    >
      <StyledDiv>
        <Paper
          elevation={10}
          className={classes.addList}
          id={`${id}-infinite-scroll`}
        >
          {baseList.map((item, index) => {
            if (ddList[id].some((elem) => elem.id === item.id)) return null;
            else
              return (
                <Box
                  key={`base-list-${id}-${index + 1}`}
                  sx={{ marginRight: "1rem", marginBottom: "1rem" }}
                >
                  <ImageAndTitle
                    image={item[logoKey] || item[subLogoKey]}
                    title={item.displayName || item.name}
                    onAdd={() => handleAddElement(item)}
                  />
                </Box>
              );
          })}
        </Paper>
      </StyledDiv>
    </InfiniteScroll>
  );
};

export default InfiniteContent;
